import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";

const initialState = {
    newlyCreatedCargo: null,
    newlyCreatedCargoPort: null,
    newlyCreatedClient: null,
    newlyCreatedClientContact: null,
    newlyCreatedClientRate: null,
    newlyCreatedCommodity: null,
    newlyCreatedCompany: null,
    newlyCreatedCompanyContact: null,
    newlyCreatedCost: null,
    newlyCreatedCountry: null,
    newlyCreatedCurrency: null,
    newlyCreatedFog: null,
    newlyCreatedInvoice: null,
    newlyCreatedPort: null,
    newlyCreatedUnderwriter: null,
    newlyCreatedUnderwriterRate: null,
    newlyCreatedVessel: null,
};

export default function create(state = initialState, action) {
    let newState = Object.assign({}, state);
    let id = null;

    switch (action.type) {
        /*case actions.NEWLYCREATED_NEW:
            let id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedElement = id;
            break;

        case actions.NEWLYCREATED_CLOSE:
            newState.newlyCreatedElement = null;
            break;
            */
        case actions.NEWLYCREATED_NEW_CARGO:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedCargo = id;
            break;

        case actions.NEWLYCREATED_CLOSE_CARGO:
            newState.newlyCreatedCargo = null;
            break;


        case actions.NEWLYCREATED_NEW_CARGO_PORT:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedCargoPort = id;
            break;

        case actions.NEWLYCREATED_CLOSE_CARGO_PORT:
            newState.newlyCreatedCargoPort = null;
            break;


        case actions.NEWLYCREATED_NEW_CLIENT:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedClient = id;
            break;

        case actions.NEWLYCREATED_CLOSE_CLIENT:
            newState.newlyCreatedClient = null;
            break;


        case actions.NEWLYCREATED_NEW_CLIENT_CONTACT:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedClientContact = id;
            break;

        case actions.NEWLYCREATED_CLOSE_CLIENT_CONTACT:
            newState.newlyCreatedClientContact = null;
            break;


        case actions.NEWLYCREATED_NEW_CLIENT_RATE:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedClientRate = id;
            break;

        case actions.NEWLYCREATED_CLOSE_CLIENT_RATE:
            newState.newlyCreatedClientRate = null;
            break;


        case actions.NEWLYCREATED_NEW_COMMODITY:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedCommodity = id;
            break;

        case actions.NEWLYCREATED_CLOSE_COMMODITY:
            newState.newlyCreatedCommodity = null;
            break;


        case actions.NEWLYCREATED_NEW_COMMODITY_GROUP:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedCommodityGroup = id;
            break;

        case actions.NEWLYCREATED_CLOSE_COMMODITY_GROUP:
            newState.newlyCreatedCommodityGroup = null;
            break;


        case actions.NEWLYCREATED_NEW_COMPANY:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedCompany = id;
            break;

        case actions.NEWLYCREATED_CLOSE_COMPANY:
            newState.newlyCreatedCompany = null;
            break;


        case actions.NEWLYCREATED_NEW_COMPANY_CONTACT:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedCompanyContact = id;
            break;

        case actions.NEWLYCREATED_CLOSE_COMPANY_CONTACT:
            newState.newlyCreatedCompanyContact = null;
            break;


        case actions.NEWLYCREATED_NEW_COST:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedCost = id;
            break;

        case actions.NEWLYCREATED_CLOSE_COST:
            newState.newlyCreatedCost = null;
            break;


        case actions.NEWLYCREATED_NEW_COUNTRY:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedCountry = id;
            break;

        case actions.NEWLYCREATED_CLOSE_COUNTRY:
            newState.newlyCreatedCountry = null;
            break;


        case actions.NEWLYCREATED_NEW_CURRENCY:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedCurrency = id;
            break;

        case actions.NEWLYCREATED_CLOSE_CURRENCY:
            newState.newlyCreatedCurrency = null;
            break;


        case actions.NEWLYCREATED_NEW_FOG:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedFog = id;
            break;

        case actions.NEWLYCREATED_CLOSE_FOG:
            newState.newlyCreatedFog = null;
            break;


        case actions.NEWLYCREATED_NEW_INVOICE:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedInvoice = id;
            break;

        case actions.NEWLYCREATED_CLOSE_INVOICE:
            newState.newlyCreatedInvoice = null;
            break;


        case actions.NEWLYCREATED_NEW_PORT:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedPort = id;
            break;

        case actions.NEWLYCREATED_CLOSE_PORT:
            newState.newlyCreatedPort = null;
            break;


        case actions.NEWLYCREATED_NEW_UNDERWRITER:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedUnderwriter = id;
            break;

        case actions.NEWLYCREATED_CLOSE_UNDERWRITER:
            newState.newlyCreatedUnderwriter = null;
            break;


        case actions.NEWLYCREATED_NEW_UNDERWRITER_RATE:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedUnderwriterRate = id;
            break;

        case actions.NEWLYCREATED_CLOSE_UNDERWRITER_RATE:
            newState.newlyCreatedUnderwriterRate = null;
            break;


        case actions.NEWLYCREATED_NEW_VESSEL:
            id = null;

            if (utils.notNullNorUndefined(action.payload) && utils.notNullNorUndefined(action.payload.id)) {
                id = action.payload.id;
            }
            newState.newlyCreatedVessel = id;
            break;

        case actions.NEWLYCREATED_CLOSE_VESSEL:
            newState.newlyCreatedVessel = null;
            break;

        default:
            break;
    }
    return newState;
};


// WEBPACK FOOTER //
// ./src/reducers/creation.js